import React from 'react';
import { Check, CheckCheck } from 'lucide-react';

const MessageStatus = ({ status }) => {
  const statusLower = status?.toLowerCase();

  switch (statusLower) {
    case 'sent':
    case 'accepted':
      return <Check size={14} className="text-gray-400" />;
    case 'delivered':
      return <CheckCheck size={14} className="text-gray-400" />;
    case 'read':
      return <CheckCheck size={14} style={{ color: '#53bdeb' }} />;
    case 'failed':
    case 'error':
    case 'erro':
      return <span className="text-red-500 text-xs">❌</span>;
    default:
      // Sem status: assume enviada (✓ cinza)
      return <Check size={14} className="text-gray-400" />;
  }
};

export default MessageStatus;
